import React, {
    useEffect, useContext, useState, useCallback, useRef
} from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/services';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { withRouter, Link } from 'react-router-dom';
import { ClaimService } from 'gw-capability-claim';
import { useAuthentication } from 'gw-digital-auth-react';
import { Icon, InfoLabel } from '@jutro/components';
import { LobIconUtil } from 'gw-portals-util-js';
import { getNormalizedLOBName } from 'gw-portals-config-js';
import {
    ClaimLobOptionsMenu, ContactLinkComponent, claimsMessages
} from 'gw-capability-claim-react';
import {preLoadInfo} from '../../app/preLoadInfo';
import metadata from './LandingPage.metadata.json5';
import styles from './LandingPage.module.scss';
import analyticsTracking from '../../app/AnalyticsTrackerUtil';

function LandingPage({ history }) {
    const localeService = ServiceManager.getService('locale-service');
    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    //For filter dropdown and search box.
    const [searchFilterOptionsDropdown, updateSearchFilterOptionsDropdown] = useState([]);
    const [searchFilterDropdownValue, setSearchFilterDropdownValue] = useState(undefined);
    const refsearchFilterDropdownValue = useRef(undefined);
    const refsearchValue = useRef(undefined);
    const [searchErrorMessage, setsearchErrorMessage] = useState({info: true, defaultMessage: ''});
    const [catchSearchError,setCatchSearchError] = useState(false);
    const [catchSearchErrorMsg,setCatchSearchErrorMsg] = useState({defaultMessage: ''});
    const [searchPlaceHolder, setsearchPlaceHolder] = useState();
    const [searchInputQuery, setSearchInputQuery] = useState(undefined);
    const [queryValidation, setqueryValidation] = useState(false);
    const [searchInputQueryValue, setsearchInputQueryValue] = useState(undefined);
    const [dropdownQueryValue, setdropdownQueryValue] = useState(undefined);


    const policyNumberRegex = /^([A-Z]{2}[0-9]{8})$/;
    const claimNumberRegex = /^([A-Z]{2}\/[0-9]{1}\/[A-Z ]{2}\/[0-9]{6})$/;
    const searchErrorClass = searchErrorMessage.info ? '' : 'searchMessageError';

    const [tileState, setTileState] = useState('recentlynotified');
    const [tableHeading, setTableHeading] = useState('');
    const pageSizeSelectedOption = useRef(24);
    const [isClosed, setIsClosed] = useState(true);

    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const noDataMsg = useRef(translator(claimsMessages.noClaimsResult));

    useEffect(() => {
        const searchFilterOptionsDropdownList = [{ code: 'claimnumber', name: 'By Claim Number' },
            { code: 'insured', name: 'By Insured' }, { code: 'policynumber', name: 'By Policy Number' },
            { code: 'vehicleregistration', name: 'By Vehicle Registration' }, { code: 'brokerreference', name: 'By Broker Reference' }];
        const searchFilterOptionsDropdown = searchFilterOptionsDropdownList.map((searchDropdown) => {
            return {
                code: searchDropdown.code,
                name: translator({
                    id: searchDropdown.name,
                    defaultMessage: searchDropdown.name
                })
            };
        });
        updateSearchFilterOptionsDropdown(searchFilterOptionsDropdown);
        setsearchPlaceHolder(claimsMessages.searchClaims);
        // Disabling to prevent continues re-rendering
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const processClaimsData = useCallback(
        (claimsData) => {
            if (!_.isEmpty(claimsData)) {
                let claimsArrayResult = claimsData;
                claimsArrayResult = claimsArrayResult.map((claimInfo) => {
                    const claims = {
                        product: claimInfo.lineOfBusinessCode,
                        coronetClaimNumber: claimInfo.coronetClaimNumber_Ext,
                        claimNumber: claimInfo.claimNumber,
                        dateOfLoss: intl.formatDate(new Date(claimInfo.lossDate), { year: 'numeric', month: 'numeric', day: 'numeric' }),
                        status: translator({
                            id: `typekey.ClaimState.${claimInfo.claimState}`,
                            defaultMessage: claimInfo.claimState
                        }),
                        insuredContact: claimInfo.insuredContact,
                        policyNumber: claimInfo.policyNumber,
                        totalIncurredNet: claimInfo.totalIncurredNet,
                        totalPayments: claimInfo.totalPayments,
                        registrationNumber: claimInfo.registrationNumber,
                        driverName: claimInfo.driverName
                    };
                    return claims;
                });
                return claimsArrayResult;
            }
            return [];
        },
        [intl, translator]
    );
    const getClaims = useCallback(
        (query, paginationParams) => {
            const claimsPromise = ClaimService.getClaimSummaries(query, paginationParams, authHeader);
            return claimsPromise
                .then((responseData) => {
                    setCatchSearchError(false);
                    setCatchSearchErrorMsg(claimsMessages.serverCurrentlyUnavailable);
                    const data = processClaimsData(responseData.items);
                    const result = {
                        rows:data,
                        numberOfRows: responseData.maxNumberOfResults,
                    };
            
                    return new Promise(resolve => setTimeout(resolve, 500, result));
                })
                .catch((err)=>{
                    setCatchSearchError(true);
                    if (err.baseError !==undefined && err.baseError.message === 'Timeout_Ext') {
                        setCatchSearchErrorMsg(claimsMessages.serverTimeout);
                    } else {
                        setCatchSearchErrorMsg(claimsMessages.serverCurrentlyUnavailable);
                    }
                })
        },
        [loadClaimData,authHeader, processClaimsData,setCatchSearchError]
    );

    const loadClaimData = useCallback(
        (filters) => {
                setqueryValidation(false);
                let claimStates = isClosed ? ['open', 'draft', 'closed'] : ['open', 'draft'];
                let startIndex = 0;
                let offsetEndMinusOne = pageSizeSelectedOption.current;
                if((_.isEmpty(refsearchFilterDropdownValue.current) && !_.isEmpty(refsearchValue.current)) || !validateSearchQuery(refsearchFilterDropdownValue.current,refsearchValue.current)){
                    const result = {
                        rows:[],
                        numberOfRows: 0,
                    };
                    return new Promise(resolve => setTimeout(resolve, 500, result));;
                }
                setqueryValidation(true);
                if(filters && filters.pageSize !==undefined && filters.page !==undefined){
                    pageSizeSelectedOption.current=filters.pageSize;
                    startIndex = filters.pageSize * filters.page;
                    offsetEndMinusOne = startIndex + filters.pageSize - 1;
                }           
                
                const paginationParams = {
                    offsetStart: startIndex,
                    offsetEnd: offsetEndMinusOne,
                };

                const query = {
                    claimStates: claimStates,
                    queryText: refsearchValue.current,
                    queryFilter_Ext: tileState,
                    queryCriteria_Ext: refsearchFilterDropdownValue.current,
                    policyType: undefined,
                };
                analyticsTracking.searchInputDropDown(refsearchFilterDropdownValue.current,refsearchValue.current);
                analyticsTracking.setProfileID(authHeader);

                return getClaims(query, paginationParams);
            },
        [dropdownQueryValue,searchInputQueryValue,tileState, isClosed, getClaims, translator]
    );

  const handleFilterChange = useCallback(
        (value, id,searchFilterDropdownValue) => {
            if (id === 'onSearchFilterEnter') {
                if(!_.isEmpty(searchFilterDropdownValue) && validateSearchQuery(searchFilterDropdownValue,value)){
                    setsearchInputQueryValue(value);
                    setdropdownQueryValue(searchFilterDropdownValue);
                    //loadClaimData({"searchFilterDropdownValue":searchFilterDropdownValue,"searchInputQuery":value});
                }
            }
        },
        [loadClaimData]
    );

    const getCell = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                product: translator(claimsMessages.line),
                dateOfLoss: translator(claimsMessages.dateOfLossClaimDetail)
            };
            return <span title={toolTipMessage[property.id]}>{item[property.id]}</span>;
        },
        [translator]
    );

    const getStatusCell = useCallback(
        (item, index, property) => {
            const titleMessage = translator(claimsMessages.claimStatus);
            const status = item[property.id];
            let typeStatus = 'success';

            if (status === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'draft' })) {
                typeStatus = 'warning';
            } else if (status === translator({ id: 'typekey.ClaimState.closed', defaultMessage: 'closed' })) {
                typeStatus = 'neutral';
            }

            return (
                <InfoLabel type={typeStatus} size="small" title={titleMessage[property.id]}>
                    {item[property.id]}
                </InfoLabel>
            );
        },
        [translator]
    );

    const getAccountContactCell = useCallback((item, index, property) => {
        const contacts = item[property.id];
        return <ContactLinkComponent id="contactCell" className={styles.accountContactCell} contactDetails={contacts} rowIndex={index} />;
    }, []);

    const getLink = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                claimNumber: translator(claimsMessages.claimNumber)
            };
            if (
                property.id === 'claimNumber'
                && item.status
                === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'draft' })
            ) {
                const redirectpath = {
                    pathname: '/fnol-select-policy',
                    state: {
                        claimNumber: item.claimNumber,
                        redirectPath: '/claims',
                        claimStatus: item.status
                    }
                };
                return (
                    <Link
                        to={redirectpath}
                        className={styles.gwClaimsLinkContent}
                        title={toolTipMessage[property.id]}
                    >
                        {item[property.id]}
                    </Link>
                );
            }
            const redirectRoute = `/claims/${item.claimNumber}`;
            const redirectPath = {
                pathname: redirectRoute,
                state: {
                    claimNumber: item.claimNumber,
                    redirectPath: '/claims',
                    claimStatus: item.status
                }
            };
            return (
                <Link
                    to={redirectPath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage[property.id]}
                >
                    {item.coronetClaimNumber}
                </Link>
            );
        },
        [translator]
    );

    const getProductIcon = useCallback((item) => {
        const icon = LobIconUtil.getMaterialIcon(item.product);
        return <Icon icon={icon} title={item.product} key={item.product} />;
    }, []);

    const handleFileClick = useCallback(() => {
        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                redirectPath: '/claims'
            }
        });
    }, [history]);

    const handleOnTileClick = (id) => {
        setTileState(id);
        const tileTitles = {
            all: 'All Claims',
            allopen: 'Open Claims',
            allclosed: 'Closed Claims',
            recentlynotified: 'Recently Notified',
            recentlyclosed: 'Recently Closed',
            makeClaim: 'Make a Claim',
        };
        setTableHeading(tileTitles[id] || '');
        analyticsTracking.getActiveTile(id);
    };
    const validateSearchQuery = (searchFilterDropdownValue,searchInputQuery) => {
        setsearchErrorMessage('');
        if (searchFilterDropdownValue === 'policynumber' &&
            !policyNumberRegex.test(searchInputQuery) && preLoadInfo.policyNumberNewSearch) {
            setsearchErrorMessage(claimsMessages.pleaseCheckPolicyFormat);
            return false;
        } else if (searchFilterDropdownValue === 'claimnumber' &&
            !claimNumberRegex.test(searchInputQuery) && preLoadInfo.claimNumberNewSearch) {
            setsearchErrorMessage(claimsMessages.pleaseCheckClaimNumberFormat);
            return false;
        }
        return true;
    };
    let slashAddedAutomatically = false;
    let blockDoubleCharDeletion = true;
    const triggerClaimNumberMask = (newVal, oldVal) => {
        const slashWasAdded = newVal.slice(-1) === '/';
        const slashAddedManually = slashWasAdded ? newVal.length !== 3 && newVal.length !== 5 && newVal.length !== 8 : false;
        let slashedSearch = newVal;
        if (slashAddedManually) {
            slashedSearch = slashedSearch.slice(0, -1);
            slashAddedAutomatically = false;
            blockDoubleCharDeletion = true;
        } else if (!slashWasAdded || slashAddedAutomatically) {
            const deletingStuff = newVal.length < oldVal.length;
            const slashWasLast = oldVal.slice(-1) === '/';
            if (deletingStuff && slashWasLast && !blockDoubleCharDeletion) {
                slashedSearch = slashedSearch.slice(0, -1);
            } else if (!(deletingStuff && slashWasLast)) {
                const length = slashedSearch.length;
                if (length === 2 || length === 4 || length === 7) {
                    slashedSearch = slashedSearch.concat('/');
                   slashAddedAutomatically = true;
                }
            } else {
                slashAddedAutomatically = false;
                blockDoubleCharDeletion = false;
            }

        }
        return slashedSearch;
    };
    
    const updateSearchLabelsOnFilterChange = (value) => {
        if (value === 'claimnumber' && preLoadInfo.claimNumberNewSearch) {
            claimsMessages.claimFormatShouldBe.info = true;
            setsearchErrorMessage(claimsMessages.claimFormatShouldBe);
            setsearchPlaceHolder(claimsMessages.searchByClaimNumber);
        } else {
            setsearchPlaceHolder(claimsMessages.searchClaims);
        }
    }
    
    const onSearchFilterDropdownChange = (newValue, path) => {
        refsearchFilterDropdownValue.current = newValue;
        setSearchFilterDropdownValue(newValue);
        setsearchErrorMessage("");
        updateSearchLabelsOnFilterChange(newValue);
    };
    
    const onSearchInputChange = (newValue,oldValue) => {
        setqueryValidation(false);
        const newValueInCaps = newValue.toUpperCase();
        if (searchFilterDropdownValue === 'claimnumber' && searchInputQuery && searchInputQuery !== newValue 
            && preLoadInfo && preLoadInfo.claimNumberNewSearch) {
            const maskedValue = triggerClaimNumberMask(newValueInCaps, searchInputQuery);
            refsearchValue.current = maskedValue;
            setSearchInputQuery(maskedValue);
        }else{
            refsearchValue.current = newValueInCaps
            setSearchInputQuery(newValueInCaps);
        }
    };

    const currentView = tileState;
    const getNoDataMessage = (currentView, queryCriteria_Ext, searchInputQuery, queryValidation) => {
        if(queryValidation){
            if(!!queryCriteria_Ext && !!searchInputQuery){
                noDataMsg.current =  translator(claimsMessages.noMatchingClaim);
            }else if (currentView == 'recentlyclosed') {
                noDataMsg.current= translator(claimsMessages.noClaimsRecentlyClosed);
            }else{
                noDataMsg.current = translator(claimsMessages.noClaimsResult)
            }
        }else{
            if(!queryCriteria_Ext && !!searchInputQuery){
                noDataMsg.current= translator(claimsMessages.noFilterSelected);
            }
        }
        return noDataMsg.current;
    }

    const lossDateSorter = (a , b) => {
        a = a.split('/');
        b = b.split('/');
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
    }
    const overrides = {
        searchFilterDropdown:{
            availableValues: searchFilterOptionsDropdown,  
            value: searchFilterDropdownValue,
            onValueChange: onSearchFilterDropdownChange,
            placeholder: translator(claimsMessages.searchCriteria),
        },
        searchErrorMessage: {
            content: searchErrorMessage.defaultMessage,
            className: searchErrorClass,
        },
        recentlyViewedId: {
            loaded: !isLoading
        },
        recentlyViewedTableGrid: {
            onFetchData:loadClaimData,
            noDataText: getNoDataMessage(tileState,refsearchFilterDropdownValue.current,searchInputQuery,queryValidation)
        },
        [currentView]: {
            active: true
        },
        searchFilter: {
            placeholder : translator(searchPlaceHolder),
            onValueChange: onSearchInputChange,
            value: searchInputQuery,
            onEnter: () => {
                handleFilterChange(searchInputQuery, 'onSearchFilterEnter',searchFilterDropdownValue);
            }
        },
        searchFilterButton:{
            onClick: () => {
                handleFilterChange(searchInputQuery, 'onSearchFilterEnter',searchFilterDropdownValue);
            }
        },
        accountPageTileContainer:{
            visible: !catchSearchError
        },
        claimListTableContainer:{
            visible: !catchSearchError
        },
        catchSearchError:{
            visible: catchSearchError,
            content: catchSearchErrorMsg.defaultMessage,
            className: styles.catchErrorMessage,
        },
        globalizationChooserField: {
            onLanguageValueChange: localeService.saveLanguage,
            languageValue: localeService.getStoredLanguage()
        },
        tableHeading: {
            content: tableHeading,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell: getCell,
            getLink: getLink,
            getProductIcon: getProductIcon,
            getAccountContactCell: getAccountContactCell,
            getStatusCell: getStatusCell,
            handleClosedClaims: setIsClosed,
            onSearchFilterDropdownChange:onSearchFilterDropdownChange,
            handleFileClick: handleFileClick,
            handleOnTileClick:handleOnTileClick,
            lossDateSorter:lossDateSorter
        },
        resolveComponentMap: {
            claimloboptionsmenu: ClaimLobOptionsMenu
        }
    };

    return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
}

export default withRouter(LandingPage);
